import { Field, Int, ObjectType } from '@nestjs/graphql'

export const REFERRAL_TRANSACTION_TYPE = {
  ReferralPending: 'ReferralPending',
  ReferralConfirmed: 'ReferralConfirmed',
  CreditUsed: 'CreditUsed',
  PlanBonus: 'PlanBonus'
} as const

export type ReferralTransactionType = typeof REFERRAL_TRANSACTION_TYPE[keyof typeof REFERRAL_TRANSACTION_TYPE]

@ObjectType()
export class ReferralTransactionDto {
  @Field()
  id!: string

  @Field()
  type!: string

  @Field(t => Date)
  date!: Date

  @Field(t => Int)
  amountCents!: number

  @Field(t => Int, { nullable: true })
  balanceAfterCents?: number

  @Field({ nullable: true })
  maskedEmail?: string

  @Field({ nullable: true })
  description?: string

  @Field()
  isPending!: boolean

  /**
   * When a pending referral's credit becomes spendable. Unset once it has.
   */
  @Field(t => Date, { nullable: true })
  availableDate?: Date
}
